
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tx/[...slug]",
      function () {
        return require("private-next-pages/tx/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tx/[...slug]"])
      });
    }
  